import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async list() {
    return wrapEndpoint(() => client.GET('/interested-disease'))
  },
}
